import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChildren,
  ElementRef,
  QueryList,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { InspectionPoint, Inspection } from '../../shared/models/index';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { AppConstants } from '../../utils/appConstants.class';

@Component({
    selector: 'point-detail',
    templateUrl: './detail.component.html',
    standalone: false
})
export class InspectionPointDetailComponent implements OnInit, AfterViewInit {
  @Input() public point: InspectionPoint;
  @Input() public inspectionId: string;
  @Input() public processing;
  @Input() public showHelp: boolean;
  @Output() public toggleUpdateStatus: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  @Input() query = '';
  @ViewChildren('plugin', { read: ElementRef }) plugins: QueryList<ElementRef>;
  @ViewChild('scroll', { read: ElementRef }) scroll: ElementRef;
  inspection: Inspection;

  public selection: any = {};
  errorMessage: string;

  public loading: Boolean = true;

  public currentIndex = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  public updateStatus() {
    this.toggleUpdateStatus.emit(this.point);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  public isDone(): boolean {
    return InspectionPoint.Done === this.point.status;
  }

  ngOnInit(): void {
    const pluginId = sessionStorage.getItem(AppConstants.LAST_OPENED_PLUGIN_ID);
    this.currentIndex = (this.point.plugins || []).sort((a, b) => a.order - b.order).findIndex((p) => p.id === pluginId);
    this.inspection = this.point.inspection;
    this.cdr.detectChanges();
  }

  public currentYPosition() {
    return this.scroll.nativeElement.scrollTop;
  }

  public scrollTo(value: number) {
    this.scroll.nativeElement.scrollTop = value;
    this.cdr.detectChanges();
  }

  public gotoNextPlugin() {
    this.updateCurrentIndex();
    if (this.currentIndex < this.plugins.length) {
      this.currentIndex++;
      const nextElement = this.plugins.toArray()[this.currentIndex].nativeElement;
      this.scrollTo(nextElement.offsetTop);
    }
  }

  public gotoPreviousPlugin() {
    if (this.currentIndex <= 0) return;
    this.updateCurrentIndex();
    if (this.currentIndex > 1) {
      this.currentIndex--;
      const nextElement = this.plugins.toArray()[this.currentIndex].nativeElement;
      this.scrollTo(nextElement.offsetTop);
    } else {
      this.scrollTo(0);
    }
  }

  gotoPlugin() {
    const nextElement = this.plugins.toArray()[this.currentIndex].nativeElement;
    this.scrollTo(nextElement.offsetTop);
  }

  public updateCurrentIndex() {
    const currentPosition = this.currentYPosition();
    const values = this.plugins.toArray();
    let firstPosition = Math.abs(values[0].nativeElement.offsetTop - currentPosition);
    let currentIndex = 0;

    _.forEach(this.plugins.toArray(), (el: any, index: number) => {
      const pOffset = el.nativeElement.offsetTop;
      const nextPosition = Math.abs(pOffset - currentPosition);
      if (nextPosition < firstPosition) {
        currentIndex = index;
        firstPosition = nextPosition;
      }
    });
    this.currentIndex = currentIndex;
  }

  public getEditNotesRoute() {
    return ['/' + environment.applicationRoute, 'inspections', this.inspectionId, 'points', this.point.id, 'editnotes'];
  }

  ngAfterViewInit() {
    if (this.currentIndex > 0) {
      setTimeout(() => this.gotoPlugin());
      return;
    }

    this.currentIndex = 0;
  }
}
